import { authHeaders, baseUrl, handleResponse } from './apiUtils';

function getSettlements(month, schoolYearStartYear) {
  const params = new URLSearchParams({ month, schoolYearStartYear });
  return fetch(`${baseUrl}teacherledger/settlements?${params}`, { headers: authHeaders() }).then(handleResponse);
}

function saveSettlement(settlement, command) {
  return fetch(`${baseUrl}teacherledger/settlements`, {
    method: 'POST',
    headers: authHeaders({ 'content-type': 'application/json' }),
    body: JSON.stringify({ teacherId: settlement.teacherId,
      month: settlement.month,
      expectedRevision: settlement.revision,
      fingerprint: settlement.fingerprint,
      ...command }),
  }).then(handleResponse);
}

function getRates(teacherId) {
  return fetch(`${baseUrl}teacherledger/rates?${new URLSearchParams({ teacherId })}`, { headers: authHeaders() }).then(handleResponse);
}

function saveRate(teacherId, rate, expectedRevision) {
  return fetch(`${baseUrl}teacherledger/rates`, {
    method: 'POST', headers: authHeaders({ 'content-type': 'application/json' }), body: JSON.stringify({ teacherId, rate, expectedRevision }),
  }).then(handleResponse);
}

export default { getSettlements, saveSettlement, getRates, saveRate };
